<template>
  <div class="s-modal-wrapper">
    <div ref="modalContainer" class="s-modal-container" :style="{maxWidth: modalContainerMaxWidth}">
      <div class="s-modal-header" :class="{'shadow': modalHeaderShadow}">
        <slot name="header">
          <h3 />
        </slot>
        <button class="btn-close" type="button" @click="$emit('close')">
          &times;
        </button>
      </div>

      <div class="s-modal-body" :class="{'no-body-padding': noBodyPadding}">
        <slot name="body">
          default body<br>
          default body<br>
          default body<br>
          default body<br>
          default body<br>
          default body<br>
          default body<br>
        </slot>
      </div>

      <div class="s-modal-footer" :class="{'shadow': modalFooterShadow}">
        <slot name="footer">
          <button class="btn" @click="$emit('close')">
            OK
          </button>
        </slot>
      </div>
    </div>
    <a class="s-modal-backdrop" @click="$emit('close')" />
  </div>
</template>

<script>
export default {
  name: 'SModal',
  props: { noBodyPadding: Boolean, size: [String, Number] },
  data: () => ({
    bodyOverflowBackup: '',
    modalFooterShadow: false,
    modalHeaderShadow: false,
    modalBodyElement: null,
    closeFromHistoryBack: false,
    parentRouteName: ''
  }),
  computed: {
    modalContainerMaxWidth () {
      if (this.size) {
        if (typeof this.size === "string") {
          switch (this.size) {
            case "sm": return "300px"
            case "lg": return "800px"
            case "xl": return "1140px"
          }
        } else if (typeof this.size === "number") {
          return this.size + "px"
        }
      }
      return "580px"
    }
  },
  created() {
    // this.$refs.modalContainer.style.maxWidth = this.modalContainerMaxWidth
  },
  mounted () {
    this.bodyOverflowBackup = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    this.modalBodyElement = this.$el.querySelector('.modal-body')
    // this.updateShadow();

    window.addEventListener('popstate', this.windowPopState)
    window.addEventListener('resize', this.windowResize)
    document.addEventListener('keydown', this.documentKeyDown)

    this.parentRouteName = this.$route.name
    const forAttribute = this.$el.getAttribute('for')
    history.pushState(null, null, forAttribute ? '#' + forAttribute : '')

    this.$emit('mounted');
  },
  beforeDestroy () {
    document.body.style.overflow = this.bodyOverflowBackup

    window.removeEventListener('popstate', this.windowPopState)
    window.removeEventListener('resize', this.windowResize)
    document.removeEventListener('keydown', this.documentKeyDown)

    if (!this.closeFromHistoryBack && this.parentRouteName === this.$route.name) {
      history.back()
    }
  },
  methods: {
    updateShadow () {
      if (this.modalBodyElement.scrollTop === 0 && this.modalHeaderShadow) {
        this.modalHeaderShadow = false
      }
      if (this.modalBodyElement.scrollTop > 0 && !this.modalHeaderShadow) {
        this.modalHeaderShadow = true
      }
      if (this.modalBodyElement.scrollTop + this.modalBodyElement.offsetHeight >= this.modalBodyElement.scrollHeight &&
          this.modalFooterShadow) {
        this.modalFooterShadow = false
      }
      if (this.modalBodyElement.scrollTop + this.modalBodyElement.offsetHeight < this.modalBodyElement.scrollHeight &&
          !this.modalFooterShadow) {
        this.modalFooterShadow = true
      }
    },
    windowPopState () {
      this.closeFromHistoryBack = true
      this.$emit('close')
    },
    windowResize () {
      // this.updateShadow()
      if (this.$el.offsetHeight === 0) {
        this.$emit('close')
      }
    },
    documentKeyDown (event) {
      if (event.key === 'Escape') {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
  .s-modal-wrapper {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: opacity .3s ease;
  }

  .s-modal-container {
    position: relative;
    z-index: 1;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    width: calc(100% - 20px);
    margin: 20px 10px;
    max-width: 580px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  @media screen and (orientation:landscape) {
    .s-modal-container {
      width: calc(100% - 20px);
      margin: 10px 10px;
    }
  }

  .s-modal-header {
    display: flex;
    align-items: center;
    padding: 0 1rem;
    height: 3.5714285rem;
    position: relative;
    background: #e8e8e8;
    color: #2c3e50;
    border-bottom: 1px solid #ddd;
    box-sizing: content-box;
    flex-shrink: 0;
  }

  .s-modal-header.shadow {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .s-modal-header h3 {
    margin: 0;
    flex-grow: 1;
    max-height: 3rem;
    overflow: hidden;
    font-size: 1.17rem;
    line-height: 1.25;
    font-weight: bold;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .s-modal-header .btn-close {
    background: transparent;
    border: none;
    font-size: 22px;
    cursor: pointer;
    margin: 0;
    line-height: 1;
    width: 22px;
    height: 22px;
    color: #51419d;
    padding: 0 0 0 1rem;
    box-sizing: content-box;
    outline: none;
  }

  .s-modal-body {
    padding: 1rem;
    overflow: auto;
    background: #fff;
  }

  .s-modal-body.no-body-padding {
    padding: 0;
  }

  .s-modal-footer {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 1rem;
    min-height: 3.5714285rem;
    position: relative;
    background: #e8e8e8;
    box-sizing: content-box;
    border-top: 1px solid #ddd;
  }

  .s-modal-footer.shadow {
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }

  .s-modal-footer > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 0 0 5px 0;
  }

  .btn {
    margin: 5px 0 0 5px;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .s-modal-enter {
    opacity: 0;
  }

  .s-modal-leave-active {
    opacity: 0;
  }

  .s-modal-enter .s-modal-container,
  .s-modal-leave-active .s-modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .s-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100vw;
    height: 100vh;
    /*background-color: #000;*/
    background-color: rgba(18, 15, 33, 0.7);
    /*opacity: .5;*/
  }
</style>
